var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"w-full form-control form-input form-input-bordered",attrs:{"type":"text","placeholder":_vm.$t('Enter number')},domProps:{"value":_vm.item.response},on:{"change":_vm.handleChange,"keyup":_vm.handleChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }